import ReducerRegistry from '../base/redux/ReducerRegistry';
import { TOGGLE_REACTIONS_VISIBLE, SET_REACTION_QUEUE, ADD_REACTION_BUFFER, FLUSH_REACTION_BUFFER, SHOW_SOUNDS_NOTIFICATION } from './actionTypes';
/**
 * Returns initial state for reactions' part of Redux store.
 *
 * @private
 * @returns {IReactionsState}
 */
function _getInitialState() {
    return {
        visible: false,
        buffer: [],
        timeoutID: null,
        queue: [],
        notificationDisplayed: false
    };
}
ReducerRegistry.register('features/reactions', (state = _getInitialState(), action) => {
    switch (action.type) {
        case TOGGLE_REACTIONS_VISIBLE:
            return Object.assign(Object.assign({}, state), { visible: !state.visible });
        case ADD_REACTION_BUFFER:
            return Object.assign(Object.assign({}, state), { buffer: action.buffer, timeoutID: action.timeoutID });
        case FLUSH_REACTION_BUFFER:
            return Object.assign(Object.assign({}, state), { buffer: [], timeoutID: null });
        case SET_REACTION_QUEUE: {
            return Object.assign(Object.assign({}, state), { queue: action.queue });
        }
        case SHOW_SOUNDS_NOTIFICATION: {
            return Object.assign(Object.assign({}, state), { notificationDisplayed: true });
        }
    }
    return state;
});
